"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var AngleLeft_1 = __importDefault(require("../assets/react/AngleLeft"));
var AngleRight_1 = __importDefault(require("../assets/react/AngleRight"));
var Header = function (props) {
    var prevScene = function () {
        return (React.createElement(react_router_dom_1.Link, { to: "/".concat(props.play_id, "/").concat(props.prev_scene[0], "/").concat(props.prev_scene[1]) },
            React.createElement(AngleLeft_1["default"], null)));
    };
    var currAct = function () {
        return props.curr_act && "Act ".concat(props.curr_act);
    };
    var currScene = function () {
        return props.curr_scene && "Scene ".concat(props.curr_scene);
    };
    var nextScene = function () {
        return (React.createElement(react_router_dom_1.Link, { to: "/".concat(props.play_id, "/").concat(props.next_scene[0], "/").concat(props.next_scene[1]) },
            React.createElement(AngleRight_1["default"], null)));
    };
    return (React.createElement("div", { className: "header" },
        React.createElement("div", null,
            React.createElement(react_router_dom_1.Link, { to: "/".concat(props.play_id) }, props.title)),
        React.createElement("div", null, props.prev_scene && prevScene()),
        React.createElement("div", null, currAct()),
        React.createElement("div", null, currScene()),
        React.createElement("div", null, props.next_scene && nextScene())));
};
exports["default"] = Header;
